import { useState } from "react";
import { CrearEntidadForm, Input } from "@/components/ui";
import { toastError } from "@/lib/toast";
import { useCrearOrganizacion } from "../hooks/use-organizaciones-mutations";

export function OrganizacionCrearForm({ onSalir }: { onSalir: () => void }) {
  const [rfc, setRfc] = useState("");
  const [numeroSociedad, setNumeroSociedad] = useState("");
  const [nombre, setNombre] = useState("");

  const crear = useCrearOrganizacion({ onCreado: onSalir });

  const submit = () => {
    if (!rfc.trim() || !numeroSociedad.trim() || !nombre.trim()) {
      toastError({ title: "Datos incompletos", message: "RFC, sociedad y nombre son obligatorios." });
      return;
    }
    crear.mutate({ rfc: rfc.trim().toUpperCase(), numeroSociedad: numeroSociedad.trim(), nombre: nombre.trim() });
  };

  return (
    <CrearEntidadForm
      titulo="Nueva organización"
      descripcion="RFC (12-13 chars), número de sociedad SAP y nombre legal de la entidad."
      cols={3}
      onCancelar={onSalir}
      onCrear={submit}
      creando={crear.isPending}
    >
      <Input label="RFC" placeholder="GFM980824UK0" value={rfc} onChange={(e) => setRfc(e.currentTarget.value.toUpperCase())} maxLength={13} className="font-mono" />
      <Input label="Sociedad SAP" placeholder="5001" value={numeroSociedad} onChange={(e) => setNumeroSociedad(e.currentTarget.value)} className="font-mono" />
      <Input label="Nombre" placeholder="Nombre de la sociedad" value={nombre} onChange={(e) => setNombre(e.currentTarget.value)} />
    </CrearEntidadForm>
  );
}
